export const getDetailsByCode = (details: any[], code: number | string) => {
  return (details || []).find((d) => d?.code === code);
};
